/** Acompanhar os pedidos feitos ao escritório. */
import { createFileRoute } from '@tanstack/react-router';
import { ComPortal } from '../telas/portal/casca';
import { MeusPedidos } from '../telas/portal/pedidos';

export const Route = createFileRoute('/portal/pedidos')({ component: () => <ComPortal>{(d) => <MeusPedidos d={d} />}</ComPortal> });
